export default "__VITE_ASSET__C0a_V9T4__"